module.exports = "<span ng-bind-html=\"vm.rendered\"></span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/menus/components/menu-schedule-render/menu.schedule.render.html
// module id = 783
// module chunks = 0